import type {ProCoverageItem} from '../../../../../types';

import {cn} from '@ds/helpers';

import {PRO_DELIVERY_METHOD_LABELS, PRO_ZONE_DOT_CLASS} from '../../../../../constants';

type ProReadOnlyZoneProps = {
  item: ProCoverageItem;
};

const ProReadOnlyZone: React.FC<ProReadOnlyZoneProps> = ({item}) => {
  const zones = item.polygons || [];
  const selectedCount = zones.length;

  return (
    <section className="mt-6">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h3 className="m-0 flex items-center gap-2 text-subtitle-md text-neutral-fg">
          <span
            className={cn('inline-block size-2.5 shrink-0 rounded-full', PRO_ZONE_DOT_CLASS[item.type])}
            aria-hidden
          />
          {PRO_DELIVERY_METHOD_LABELS[item.type]}
        </h3>
        <span className="shrink-0 text-body-xs text-gray-34">
          {selectedCount === 0 ? 'بدون محدوده' : `${selectedCount} محدوده فعال`}
        </span>
      </div>
      {selectedCount > 0 ? (
        <div className="flex flex-wrap gap-2" role="list" aria-label="محدوده‌های فعال">
          {zones.map((polygon, index) => (
            <span
              key={polygon.polygon_id}
              className={cn(
                'inline-flex h-8 min-w-9 items-center justify-center rounded-md px-2.5 text-body-xs text-white',
                PRO_ZONE_DOT_CLASS[item.type]
              )}
              role="listitem"
              aria-label={`محدوده ${index + 1}`}
            >
              {index + 1}
            </span>
          ))}
        </div>
      ) : null}
    </section>
  );
};

export default ProReadOnlyZone;
